const IconPlaneDeparture = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="icon-plane-departure"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="M.848,15.494l2.075,1.476c.973,.692,2.121,1.045,3.275,1.045,.828,0,1.66-.182,2.433-.55l13.932-6.677c1.241-.593,1.781-2.09,1.203-3.338-.579-1.251-2.069-1.795-3.319-1.219l-.007,.004-4.002,1.932c-.01-.008-.02-.015-.031-.022L9.185,3.492c-.734-.546-1.708-.644-2.542-.26l-.781,.367c-.458,.215-.774,.643-.846,1.144-.072,.502,.111,1.001,.488,1.335l5.346,4.785-5.06,2.442-3.238-1.189c-.778-.282-1.651-.034-2.17,.629-.307,.393-.435,.889-.361,1.397,.079,.542,.38,1.034,.828,1.352ZM6.169,5.332c-.128-.114-.188-.276-.164-.446s.127-.309,.282-.381l.778-.365c.498-.233,1.083-.173,1.55,.174l6.769,4.362-3.561,1.719L6.169,5.332ZM1.169,13.36c.182-.231,.452-.36,.729-.36,.104,0,.208,.019,.309,.056l3.437,1.262c.127,.047,.268,.039,.39-.02l14.837-7.16c.748-.344,1.641-.018,1.989,.732,.349,.754,.022,1.658-.728,2.016l-13.932,6.677c-1.522,.725-3.322,.57-4.697-.407l-2.075-1.476c-.226-.16-.377-.409-.417-.682-.034-.235,.022-.462,.16-.638Zm22.831,10.14c0,.276-.224,.5-.5,.5H.5c-.276,0-.5-.224-.5-.5s.224-.5,.5-.5H23.5c.276,0,.5,.224,.5,.5Z" />
    </svg>
  );
};

export default IconPlaneDeparture;
